import { axios } from '@/lib/axios'
import CrudService from '@/services/crudService'

class DocumentTemplateService extends CrudService {
  constructor() {
    super('documentTemplates')
  }

  fetchVariables = async (type) => {
    const response = await axios.get(`/${this.resource}/variables`, { params: { type } })

    return response.data
  }

  previewWithSampleData = async ({ id, signed = false }) =>
    axios.get(`/${this.resource}/${id}/preview`, { params: { signed }, responseType: 'blob' })
}

export default DocumentTemplateService
